<template>
  <div :class="[$style.ThemeSwitch, $style[`ThemeSwitch--${theme}`]]" @click="handleChange">
    <button :class="$style.ThemeSwitch__Btn" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { themeProp } from '../../../helper/props';

export default defineComponent({
  emits: ['onChange'],
  props: {
    theme: themeProp,
  },
  setup() {
    return {};
  },
  methods: {
    handleChange() {
      let theme;
      if (this.theme === 'dark') {
        theme = 'light';
      } else {
        theme = 'dark';
      }
      this.$emit('onChange', theme);
    },
  },
});
</script>

<style lang="less" module>
.ThemeSwitch {
  display: flex;
  padding: 1px;
  width: 36px;
  height: 20px;
  background-color: var(--TradeSetting-switch-background);
  border-radius: 10px;
  box-sizing: border-box;
  justify-content: var(--ThemeSwitch-justify);
  cursor: pointer;

  &--dark {
    --ThemeSwitch-justify: flex-end;
    --ThemeSwitch-icon: url('../assets/night.svg');
  }
  &--light {
    --ThemeSwitch-justify: flex-start;
    --ThemeSwitch-icon: url('../assets/day.svg');
  }

  &__Btn {
    width: 18px;
    height: 18px;
    border-radius: 9px;
    border: 0 none;
    cursor: pointer;
    background: #fff var(--ThemeSwitch-icon) center center no-repeat;
  }
}
</style>
